import * as React from 'react';
import styles from './index.less';
import { FI18n, FUtil } from '@freelog/tools-lib';

export enum EResourceStatusBadge {
  'unreleased' = 0,
  'online' = 1,
  'freeze' = 2,
  'offline' = 4,
}

interface FResourceStatusBadgeProps {
  style?: React.CSSProperties;
  status?: 'online' | 'offline' | 'unreleased' | 'freeze';
}

function FResourceStatusBadge({ status = 'online', style = {} }: FResourceStatusBadgeProps) {
  const [$statusTextObj, set$statusTextObj, get$statusTextObj] = FUtil.Hook.useGetState({
    online: FI18n.i18nNext.t('filter_resource_status_availableforauth'),
    offline: FI18n.i18nNext.t('filter_resource_status_pendingauth'),
    unreleased: FI18n.i18nNext.t('filter_resource_status_prepareforrelease'),
    freeze: FI18n.i18nNext.t('filter_resource_status_removedbyfreelog'),
  });

  return (
    <label className={[styles.style, styles[status]].join(' ')} style={style}>
      {$statusTextObj[status]}
    </label>
  );
}

export default FResourceStatusBadge;

export function resourceStatus_numberToText(
  status: number,
): NonNullable<FResourceStatusBadgeProps['status']> {
  return status === 2
    ? 'freeze'
    : status === 1
    ? 'online'
    : status === 0
    ? 'unreleased'
    : 'offline';
}
